import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxBootstrapModule } from './ngx-bootstrap/ngx-bootstrap.module';
import { CountUpModule } from 'ngx-countup';
import { NgApexchartsModule } from "ng-apexcharts";
import { NgCircleProgressModule } from 'ng-circle-progress';
import { materialModule } from './material.module';
import { NgxEditorModule } from 'ngx-editor';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FullCalendarModule } from '@fullcalendar/angular';
import { HttpClientModule } from '@angular/common/http';
import { DataService } from './data/data.service';
import { MatSortModule } from '@angular/material/sort';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { HeaderComponent } from '../common-component/header/header.component';
import { SidebarComponent } from '../common-component/sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { BreadcrumbHeaderComponent } from './components/breadcrumb-header/breadcrumb-header.component';
// import { HasPermisoComponent } from './components/has-permiso/has-permiso.component';
import { ModalImagenComponent } from './modal-imagen/modal-imagen.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { SliderModule } from 'primeng/slider';
import { TagModule } from 'primeng/tag';
import { ProgressBarModule } from 'primeng/progressbar';
import { CheckboxModule } from 'primeng/checkbox';
import { ItemLoadComponent } from './components/item-load/item-load.component';
import { TableToolbarComponent } from './components/table-toolbar/table-toolbar.component';

@NgModule({
  declarations: [
    TableToolbarComponent,
    HeaderComponent,
    SidebarComponent,
    BreadcrumbHeaderComponent,
    ModalImagenComponent,
    ItemLoadComponent,
    
    // HasPermisoComponent,
  ],
  imports: [
    CommonModule,
    NgxBootstrapModule,
    CountUpModule,
    NgApexchartsModule,
    NgCircleProgressModule.forRoot({
      "radius": 40,
      "space": -10,
      "outerStrokeWidth": 10,
      "innerStrokeWidth": 10,
      "animationDuration": 1000,
      "clockwise": false,
      "startFromZero": false,
      "lazy": false,
      "outerStrokeLinecap": "square",
      "showSubtitle": false,
      "showTitle": false,
      "showUnits": false,
      "showBackground": false
    }),
    SlickCarouselModule,
    materialModule,
    NgxEditorModule,
    FullCalendarModule,
    HttpClientModule,
    MatSortModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaterialTimepickerModule,
    RouterModule,

    TableModule,   // Para <p-table>
    ButtonModule,  // Para <button pButton>
    InputTextModule,
    DropdownModule,
    MultiSelectModule,
    SliderModule,
    TagModule,
    ProgressBarModule,
    CheckboxModule,
    MatProgressSpinnerModule
    
  ],
  exports: [
    TableToolbarComponent,
    CommonModule,
    NgxBootstrapModule,
    CountUpModule,
    NgApexchartsModule,
    NgCircleProgressModule,
    SlickCarouselModule,
    materialModule,
    NgxEditorModule,
    FullCalendarModule,
    HttpClientModule,
    MatSortModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaterialTimepickerModule,
    HeaderComponent,
    SidebarComponent,
    BreadcrumbHeaderComponent,
    // HasPermisoComponent,
    TableModule,   // Para <p-table>
    ButtonModule,  // Para <button pButton>
    InputTextModule,
    DropdownModule,
    MultiSelectModule,
    SliderModule,
    TagModule,
    ProgressBarModule,
    CheckboxModule,
    ModalImagenComponent,
    ItemLoadComponent,
    MatProgressSpinnerModule,
  ],
  providers: [
    DataService,
  ]
})
export class SharedModule { }
